// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__wrap--cjPh3 .s-module__iframe--n4E8y {\n  width: 100%;\n  border: 0;\n  display: block;\n  max-width: 100%;\n  overflow-y: auto;\n  height: 100vh;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/operation/ThirdPartyPage/s.module.less"],"names":[],"mappings":"AAAA;EAEI,WAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAAJ","sourcesContent":[".wrap {\n  .iframe {\n    width: 100%;\n    border: 0;\n    display: block;\n    max-width: 100%;\n    overflow-y: auto;\n    height: 100vh;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "s-module__wrap--cjPh3",
	"iframe": "s-module__iframe--n4E8y"
};
export default ___CSS_LOADER_EXPORT___;
